import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as BlankSvg } from './assets/blank.svg';

const BlankIcon = React.forwardRef((args, ref) => <SvgIcon component={BlankSvg} ref={ref} {...args} />);

export default BlankIcon;
